/* pantallas-alumno (G), P12 de la parte 2: POR QUE EL INVITADO LLEGO AL REGISTRO.

   ARCHIVO EN ASCII A PROPOSITO (regla de la casa para los `.js` nuevos).

   Ajustes y "Earn free credits" mandan al invitado a /signup (las dos paginas lo hacen solas, con un
   `<Navigate replace>`). Desde esta rama ese rebote lleva la razon en el ESTADO de la navegacion, nunca en la
   direccion: la barra queda limpia, un enlace copiado no la arrastra y recargar no la vuelve a pintar de mas.
   El registro la lee y, si viene, pinta arriba del formulario `auth:signup.signup_guest_reason`
   ("Create a free account to open this page."). Si no viene, el registro se ve como hoy. Web y app. */

export const RAZON_PAGINA_CON_CUENTA = 'pagina_con_cuenta';

/** El estado que lleva el rebote del invitado (Ajustes y Gana creditos). */
export const ESTADO_DEL_REBOTE = Object.freeze({ razonDelRegistro: RAZON_PAGINA_CON_CUENTA });

/** Verdadero solo si el estado de la navegacion trae la razon de un guardia. */
export function vieneDelGuardia(estado) {
  return Boolean(estado && typeof estado === 'object' && estado.razonDelRegistro === RAZON_PAGINA_CON_CUENTA);
}
